<template>
  <div class="resume-content" v-if="eduInfos.length > 0">
    <div class="resume-view-section-header">EDUCATION</div>
    <div v-if="!noData">
      <div v-bind:key="index" v-for="(edu, index) in eduInfos">
        <experience-card :index="index" :edu="edu"></experience-card>
      </div>
    </div>
    <div style="margin-top: 1rem" v-if="noData">
      <div style="color: #ff5252">
        Seems like you haven't added your educational information yet!
      </div>
    </div>
  </div>
</template>

<script>
import ExperienceCard from "./education-cards";
import { SORT_PROFILE } from "../../../filters";
export default {
  name: "education-view",
  components: {
    ExperienceCard,
  },
  data: function () {
    return {
      eduInfos: [],
      noData: false,
    };
  },
  props: {
    edu: Array,
  },
  // methods: {
  //   getUserEducationalInfo: function() {
  //     const self = this;
  //     const token = JSON.parse(localStorage.getItem("token"));
  //     self
  //       .$http({
  //         method: this.$constants.METHOD.GET,
  //         url: this.$constants.BASE_URL.USER_EDUCATIONAL_INFO_URL,
  //         headers: {
  //           "content-type": this.$constants.HEADERS.TYPE.APPLICATION_JSON,
  //           Authorization: "Bearer " + token
  //         }
  //       })
  //       .then(function(response) {
  //         if (response.status === 200) {
  //           if (response.data.length > 0) {
  //             self.eduInfos = SORT_PROFILE(response.data, "is_studying");
  //           } else {
  //             self.noData = true;
  //           }
  //         } else {
  //           self.noData = true;
  //         }
  //       })
  //       .catch(function(err) {
  //         // alert(err);
  //         self.noData = true;
  //       });
  //   }
  // },
  mounted: function () {
    // this.getUserEducationalInfo();

    if (this.edu) {
      this.eduInfos = SORT_PROFILE(this.edu, "is_studying");
    }
  },
};
</script>

<style scoped>
.experience-content {
  margin-top: 2rem;
}
.header-text {
  text-align: left;
  background-color: #f7f7f7;
  padding: 0.5rem 1rem;
  color: #050505;
}
</style>
